import { render } from "./AlertBadge.vue?vue&type=template&id=0a84356a&scoped=true"
import script from "./AlertBadge.vue?vue&type=script&lang=js"
export * from "./AlertBadge.vue?vue&type=script&lang=js"

import "./AlertBadge.vue?vue&type=style&index=0&id=0a84356a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a84356a"]])

export default __exports__